export default __webpack_public_path__ + "static/media/logo.c19c3e0f.svg";